import * as React from 'react';
import { EditComponent, CustomComponentProps, CreateComponent } from 'src/components/common/Component';

export function MakerFilterEditComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <EditComponent attributes={["name"]} children={children} />
    );
}

export function MakerFilterCreateComponent(props: CustomComponentProps) {
    const { children } = props;
    return (
        <CreateComponent source={"filter"} children={children} />
    );
}